import HttpService from '../Services/HttpService';

import * as HTTP_HEADER from '../Constants/HttpHeaders';
import * as CONNECTION from '../Constants/Connection';
import * as DASHBOARD from '../Constants/Dashboard';
import moment from 'moment';

class StreamService extends HttpService {

  getNewsStream = (page?: number, pageSize?: number) => {
      let offset = 0
      if((page || page === 0) && pageSize){
        offset = page * pageSize
      }
    return window.fetch(window.appSettings.aemStreamUrl+CONNECTION.STREAM_FEED,
                        {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                          },
                          body: JSON.stringify(
                            {
                              variables:{
                                offset: offset,
                                limit: pageSize,
                                newsPublishDate: moment().format(),
                                type: DASHBOARD.STREAM_NEWS
                              }
                            }
                          )
                        }
                      );
  }

  getEventsStream = (page?: number, pageSize?: number) => {
      let offset = 0
      if((page || page === 0) && pageSize){
        offset = page * pageSize
      }
    return window.fetch(window.appSettings.aemStreamUrl+CONNECTION.STREAM_FEED,
                        {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                          },
                          body: JSON.stringify(
                            {
                              variables:{
                                offset: offset,
                                limit: pageSize,
                                currentDate: moment().startOf('day').format(),
                                type: DASHBOARD.STREAM_EVENTS
                            }
                            }
                          )
                        }
                      );
  }

  getArticle = (path: string) =>{
    return window.fetch(`${window.appSettings.aemStreamUrl}${CONNECTION.STREAM_SINGLE}${path}`);
  }

}

export default StreamService;